import EmptyLayout from '@/layouts/EmptyLayout.vue';
import { ISnotrRoute } from '..';

export default [
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      title: 'TabTitle.orders',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/orders.vue'),
  },
  {
    path: '/orders/new',
    name: 'OrdersNew',
    title: 'New order',
    meta: {
      title: 'TabTitle.newOrder',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/orders-new.vue'),
  },
  {
    path: '/orders/:id',
    name: 'OrdersEdit',
    meta: {
      title: 'TabTitle.editOrder',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/orders-edit.vue'),
  },
  {
    path: '/orders/:id/pdf',
    name: 'OrdersPdf',
    meta: {
      title: 'TabTitle.pdfOrder',
      layout: EmptyLayout,
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/orders-pdf.vue'),
    props: route => ({
      type: route.query.type || 'order',
    }),
  },
] as ISnotrRoute[];
